import React from 'react';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import './register-web-components';
import CposmProvider from 'saur-viseau-state-management/lib/common/CposmProvider';
import { createRoot } from 'react-dom/client';
import "@arcgis/core/assets/esri/themes/light/main.css";
import { ThemeProvider } from 'styled-components';
import { getTheme } from 'saur_ui_library/src/BrandsConfig';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <ThemeProvider theme={getTheme('saur')}>
    <Provider store={store}>
      <CposmProvider states={['settings']}>
        <App/>
      </CposmProvider>
    </Provider>
  </ThemeProvider>
);
